<template>
  <div class="space-y-16 max-w-5xl mx-auto">
    <Info :campaign="campaign" />
    <Schedule v-if="$membershipHasPermissionTo('read campaign schedule')" :campaign="campaign" />
    <Pricing v-if="$membershipHasPermissionTo('read campaign targeting')" :campaign="campaign" />
    <Costing
      v-if="$membershipHasPermissionTo('read campaign cost estimation')"
      :campaign="campaign"
    />
    <div v-if="$membershipHasPermissionTo('delete campaigns')">
      <RouterLink :to="{ name: 'accounts.campaigns.delete' }" class="btn btn-danger">
        {{ $t('delete') | capitalize }}
      </RouterLink>
    </div>
    <div>
      <RouterView name="modal" />
    </div>
  </div>
</template>

<script>
import { campaignMethods, campaignComputed } from '@/store/helper';
import Info from '@/components/Campaigns/Info.vue';
import Schedule from '@/components/Campaigns/Schedule.vue';
import Pricing from '@/components/Campaigns/Pricing.vue';
import Costing from '@/components/Campaigns/Costing.vue';

export default {
  name: 'ProductInfo',
  components: {
    Info,
    Schedule,
    Pricing,
    Costing,
  },
  props: {
    campaignId: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...campaignComputed,
  },
  methods: {
    ...campaignMethods,
  },
};
</script>
